import { render } from "./HomeView.vue?vue&type=template&id=7266e3e3&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=7266e3e3&lang=scss&scoped=true"

import exportComponent from "C:\\htdocs\\sputnik\\vue\\verdura-ordini-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7266e3e3"]])

export default __exports__